<template>
  <card :class="['prev-next', 'mt-4']">
    <card-actions align="left">
      <table-layout equal-cells>
        <row>
          <cell :class="['pr-1']">
            <btn
              block
              size="sm"
              color="white"
              icon-left="chevron-left"
              :title="$lang.previousPage"
              :disabled="!previous"
              :tag="previous ? 'router-link' : 'button'"
              :to="previous"
              :bg-color="$root.colors.primary"
              :color-lightness="null"
              :bg-color-lightness="$root.colors.bgColorLightness" />
          </cell>
          <cell :class="['pl-1']">
            <btn
              block
              size="sm"
              color="white"
              icon-left="chevron-right"
              :title="$lang.nextPage"
              :disabled="!next"
              :tag="next ? 'router-link' : 'button'"
              :to="next"
              :bg-color="$root.colors.primary"
              :color-lightness="null"
              :bg-color-lightness="$root.colors.bgColorLightness" />
          </cell>
        </row>
      </table-layout>
    </card-actions>
  </card>
</template>
<script>
import methods from '../mixins/methods'

export default {
  name: 'PrevNext',
  data () {
    return {
      previous: null,
      next: null
    }
  },
  mixins: [
    methods
  ],
  watch: {
    '$route.path' () {
      this.getSlugAndSection()
    }
  },
  mounted () {
    this.getSlugAndSection()
  },
  methods: {
    getSlugAndSection () {
      let path = this.$route.path.split('/')
      path.shift()
      const section = path[0]
      const slug = path[1]
      const navigationSection = this.getNavigationSection(section)
      const currentPageIndex = navigationSection.findIndex(item => item.name.replace('page-', '') === slug)
      const previous = navigationSection[currentPageIndex - 1]
      const next = navigationSection[currentPageIndex + 1]
      this.previous = previous ? previous.path : null
      this.next = next ? next.path : null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/prev-next.vue